import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import YoutubeVideo9008WiFi from 'components/Quick_Installation/Set_Up_A_Wireless_Connection/YoutubeVideoCard9008WiFi';
import YoutubeVideo8015WiFi from 'components/Quick_Installation/Set_Up_A_Wireless_Connection/YoutubeVideoCard8015WiFi';
import NavButtons from 'components/Quick_Installation/NavButtons';
import ForumBox from 'components/Quick_Installation/Set_Up_A_Wireless_Connection/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  YoutubeVideo9008WiFi,
  YoutubeVideo8015WiFi,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};